module.exports = __webpack_public_path__ + "static/media/trash.7e534728.svg";